import {
  deployment,
  job,
  joboffer,
  order,
  reason,
  supplyHelper,
  supplyManager,
  trader,
  transaction,
} from '@homeserve/vue-api-plugin';
import * as firebase from 'firebase/app';
import 'firebase/messaging';
import Vue from 'vue';
import Vuex from 'vuex';
import router from './router';
import auth from './utils/auth';

Vue.use(Vuex);

if ('PushManager' in window) {
  // The Push API is not supported. Return
  let firebaseConfig = {};
  if (process.env.VUE_APP_ENV === 'PREPROD') {
    firebaseConfig = {
      apiKey: 'AIzaSyCF48NcEMS33mndiW9WBAjBjEolCeljmGY',
      authDomain: 'ondemand-201200.firebaseapp.com',
      databaseURL: 'https://ondemand-201200.firebaseio.com',
      projectId: 'ondemand-201200',
      storageBucket: 'ondemand-201200.appspot.com',
      messagingSenderId: '29860728324',
      appId: '1:29860728324:web:f7e54173f0e979fb',
    };
  } else if (process.env.VUE_APP_ENV === 'DEV') {
    firebaseConfig = {
      apiKey: 'AIzaSyCmZzJ_ix2iolnsDJSdpZe6eikTFAF-mzY',
      authDomain: 'ondemand-development.firebaseapp.com',
      databaseURL: 'https://ondemand-development.firebaseio.com',
      projectId: 'ondemand-development',
      storageBucket: 'ondemand-development.appspot.com',
      messagingSenderId: '63577314631',
      appId: '1:63577314631:web:de603da2e6cc52be',
    };
  } else if (process.env.VUE_APP_ENV === '') {
    firebaseConfig = {
      apiKey: 'AIzaSyAGK41yrBCukGp2bNXfCleL5i6-B02LO18',
      authDomain: 'ondemand-production.firebaseapp.com',
      databaseURL: 'https://ondemand-production.firebaseio.com',
      projectId: 'ondemand-production',
      storageBucket: 'ondemand-production.appspot.com',
      messagingSenderId: '502029979884',
      appId: '1:502029979884:web:01f7de51243d3c44',
    };
  }

  firebase.initializeApp(firebaseConfig);

  Vue.prototype.$messaging = firebase.messaging();
  Vue.prototype.$messaging.usePublicVapidKey(process.env.VUE_APP_KEY_PAIR || '');
  Vue.prototype.$messaging.onTokenRefresh(async () => {
    await unregisterAppFromFCM(Store);
    await registerAppToFCM(Store);
  });
  firebase.messaging().onMessage(next => {
    if (next && next.notification) {
      router.go(0);
    }
  });

  navigator.serviceWorker.register('./service-worker.js').then(registration => {
    Vue.prototype.$messaging.useServiceWorker(registration);
  });
}

async function unregisterAppFromFCM(store) {
  if (!('PushManager' in window)) {
    return;
  }
  const registrationToken = store.getters.getFcmToken;
  if (!registrationToken) {
    return;
  }
  Vue.prototype.$messaging.deleteToken(registrationToken);
  await supplyHelper.unsubscribeFromNotifications(store, {
    registrationToken,
  });
}

export function registerAppToFCM(store) {
  if (!('PushManager' in window)) {
    return;
  }

  Vue.prototype.$messaging
    .requestPermission()
    .then(() => {
      // Get Token
      Vue.prototype.$messaging.getToken().then(async (registrationToken: string) => {
        if (!registrationToken) {
          return;
        }
        store.commit('SET_FCM_TOKEN', registrationToken);
        await supplyHelper.subscribeToNotifications(store, {
          registrationToken,
        });
      });
    })
    .catch(err => {
      // tslint:disable-next-line:no-console
      console.log('Unable to get permission to notify.', err);
    });
}
const Store = new Vuex.Store({
  state: {
    isAuthenticating: false,
    isAuthenticated: new Date().getTime() < JSON.parse(localStorage.getItem('expires_at')!) || false,
    token: localStorage.getItem('access_token') || '',
    fcmToken: localStorage.getItem('fcm_token') || '',
    error: null,
    listFilter: {
      supplyManager: localStorage.getItem('supply_manager_filter'),
      withoutExceptStatus: false,
    },
  },
  getters: {
    getFcmToken(state) {
      return state.fcmToken;
    },
    listFilter(state) {
      return state.listFilter;
    },
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_FCM_TOKEN(state, token) {
      state.fcmToken = token;
      localStorage.setItem('fcm_token', token);
    },
    SET_AUTH(state, isAuthenticated: boolean) {
      state.isAuthenticated = isAuthenticated;
    },
    LOGIN_FAILED(state, err) {
      state.error = err;
    },
    SET_AUTHENTICATING(state, isAuthenticating: boolean) {
      state.isAuthenticating = isAuthenticating;
    },
    SET_LIST_FILTER(state, filter) {
      if (filter.supplyManager) {
        localStorage.setItem('supply_manager_filter', filter.supplyManager);
      } else {
        localStorage.removeItem('supply_manager_filter');
      }

      state.listFilter = filter;
    },
  },
  actions: {
    LOGIN_FAILED({ commit }, err) {
      commit('LOGIN_FAILED', err);
    },
    async LOGOUT({ commit }) {
      await unregisterAppFromFCM(Store);
      commit('SET_FCM_TOKEN', '');
      await auth.logout();
    },

    async LOGIN({ commit }, payload: { username: string; password: string }) {
      await auth.login(payload.username, payload.password);
    },
  },
  modules: {
    api: {
      namespaced: true,
      modules: {
        order: {
          namespaced: true,
          modules: {
            order,
            job,
            transaction,
            deployment,
            reason,
          },
        },
        trader: {
          namespaced: true,
          modules: {
            trader,
            supplyManager,
          },
        },
        marketplace: {
          namespaced: true,
          modules: {
            joboffer,
          },
        },
      },
    },
  },
});

export default Store;
